import { render, staticRenderFns } from "./FormNotch.vue?vue&type=template&id=5a60053f&scoped=true&"
import script from "./FormNotch.vue?vue&type=script&lang=js&"
export * from "./FormNotch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a60053f",
  null
  
)

export default component.exports